<template>
    <div ref="singleBanner" class="banner-item-slide banner-item" 
        @mouseleave="mouseLeave()" :style="{width: `${bannerWidth}px`,height: `${bannerHeight}px`, border:`border: 2px solid #fff`, left:'-${borderWidth}px'}" 
        @click.ctrl="() => {return true;}" 
        @click.exact="gotoUrl(banner.url)">
        <a :href="banner.url" :data-qa-href="banner.urlQaTest" class="w-100 h-100 slider-item-href" :aria-label="imgAlt(banner.url)"></a>
        <div class="banner-item-border w-100">
            <Video v-if="banner.video" :vWidth="bannerHeight" :source="banner.video" :url="banner.url" :color="colorBanner(banner)"></Video>
            <BlockImage :classNames="'w-100'" :classNamesBox="'w-100 h-100'" :isScrolled="isScrolled" :image="banner.image" :title="imgAlt(banner.url)" :width="bannerWidth" :height="bannerHeight" :webpAllowed="true"></BlockImage>
        </div>
        <TimeCounter v-if="banner.timeCounter" :vWidth="bannerHeight" :timeCounter="banner.timeCounter"></TimeCounter>
    </div>
</template>
<script>
import BlockImage from './BlockImage';
import Video from './VideoBanner';
import TimeCounter from './TimeCounter';
import homeUtils from '@/Utilities/homeUtils';
export default {
    components:{
        BlockImage,
        TimeCounter,
        Video
    },
    props:{
        banner:{
            type: Object,
            default: () => {
                return{
                    selectedEle: null,
                    url: '',
                    image: '',
                    timeCounter: 0,
                    detailsContent: '',
                    blockWidth: 300,
                };
            }
        },
        isScrolled:{
            type: Boolean,
            default: false
        },
        eventMouseLeave:{
            type: Function,
            default: null
        },
        bannerWidth:{
            type: Number,
            default: 824
        },
        bannerHeight:{
            type: Number,
            default: 410
        },
        bannerTop:{
            type: Number,
            default: 68
        },
        borderWidth:{
            type: Number,
            default: 2
        }
    },
    data(){
        return{
            zoom: false
        }
    },
    methods:{
        gotoUrl(url){
            homeUtils.gotoUrl(url,null);
        },
        colorBanner(banner){
            return banner.hasOwnProperty('css_class') && banner.css_class && banner.css_class.hasOwnProperty('slide_bgcolor') ? banner.css_class.slide_bgcolor : null;
        },
        imgAlt(url){
            return url.replace(/\//g,' ').replace(/-/g,' ');
        },
        mouseLeave(){
            if(this.eventMouseLeave){
                this.eventMouseLeave();
            }
        }
    }
}
</script>